import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { PagedResponse } from '../types';
import { SmallBusinessPlan } from '../types/SmallBusinessPlan';
import { SmallBusinessPlanFilter } from '../types/SmallBusinessPlanFilter';

const URL = '/v2/admin/pricing-plans';

interface SmallBusinessPlanCreateRequest {
  tier: string;
  billingInterval: string;
  name: string;
  description: string | null;
  priceCents: number;
  seatLimit: number;
}

interface SmallBusinessPlanPatchRequest {
  name?: string;
  description?: string | null;
  seatLimit?: number;
}

class SmallBusinessPlanService {
  static findByFilter(
    filter: SmallBusinessPlanFilter,
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<SmallBusinessPlan>> {
    const params = new URLSearchParams();

    if (filter.tier) params.append('tier', filter.tier);
    if (filter.billingInterval) params.append('billingInterval', filter.billingInterval);
    if (filter.active !== undefined) params.append('active', String(filter.active));
    if (filter.limit !== undefined) params.append('limit', String(filter.limit));

    return axios.get(`${URL}?${params.toString()}`, config);
  }

  static findById(
    id: number,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<SmallBusinessPlan>> {
    return axios.get(`${URL}/${id}`, config);
  }

  static create(
    data: SmallBusinessPlanCreateRequest,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<{ id: number }>> {
    return axios.post(URL, data, config);
  }

  static patch(
    id: number,
    data: SmallBusinessPlanPatchRequest,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<SmallBusinessPlan>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static reprice(
    id: number,
    priceCents: number,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<SmallBusinessPlan>> {
    return axios.post(`${URL}/${id}/reprice`, { priceCents }, config);
  }

  static deactivate(
    id: number,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return axios.post(`${URL}/${id}/deactivate`, undefined, config);
  }
}

export { SmallBusinessPlanService };
